import React, { createContext, useContext, useState, ReactNode } from 'react'

import type { ContactFormDataType } from '@/types/components/ContactForm'

type ContactFormContextType = {
  formData: ContactFormDataType
  updateStepData: <K extends keyof ContactFormDataType>(
    step: K,
    data: ContactFormDataType[K]
  ) => void
}

const ContactFormContext = createContext<ContactFormContextType | null>(null)

export const ContactFormProvider = ({ children }: { children: ReactNode }) => {
  const [formData, setFormData] = useState<ContactFormDataType>({
    step1: {},
    step2: {},
    step3: {},
    step4: {}
  })

  const updateStepData = <K extends keyof ContactFormDataType>(
    step: K,
    data: ContactFormDataType[K]
  ) => {
    setFormData(prev => ({ ...prev, [step]: data }))
  }

  return (
    <ContactFormContext.Provider value={{ formData, updateStepData }}>
      {children}
    </ContactFormContext.Provider>
  )
}

export const useContactForm = (): ContactFormContextType => {
  const context = useContext(ContactFormContext)
  if (!context) {
    throw new Error('useContactForm must be used within a FormProvider')
  }
  return context
}
